var React = require('react');

function ArrowUp (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9,2l.7-.71L9,.6l-.7.69Zm1,36V2H8V38ZM8.3,1.29.3,9.16l1.4,1.43,8-7.88Zm0,1.42,8,7.88,1.4-1.43-8-7.87Z","transform":"translate(-0.3 -0.6)"}));
}

ArrowUp.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 17.4 37.4"};

module.exports = ArrowUp;

ArrowUp.default = ArrowUp;
